import { CareerPathwayLevel } from "@/components/career-pathway-level"
import AppLayout from "@/layouts/AppLayout"

export default function CareerPathwaySenior() {
  return (
    <CareerPathwayLevel
      config={{
        name: "Senior",
        level: 4,
        emoji: "\ud83e\udd85",
        color: "purple",
        comingSoon: true,
        description: "",
        sections: [],
        prev: { name: "Anterior: Semi Senior", url: "/growth/career-pathway/semi-senior" },
        next: { name: "Siguiente: Staff", url: "/growth/career-pathway/staff" },
      }}
    />
  )
}

CareerPathwaySenior.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
